export enum PermitStatus {
    IsValid = 'IsValid',
    InvalidSignature = 'InvalidSignature',
    Expired = 'Expired',
    NoFile = 'NoFile',
    Corrupted = 'Corrupted',
    NoServiceLicense = 'NoServiceLicense',
    MaxCountExceeded = 'MaxCountExceeded',
    NoConnection = 'NoConnection'
};